/**
 * @generated SignedSource<<5e2829663a54a68324ba2751e6babe21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QueuedJob_info$data = {
  readonly externalUrl: string;
  readonly image: string;
  readonly jobId: string;
  readonly name: string;
  readonly repository: string;
  readonly status: string;
  readonly " $fragmentType": "QueuedJob_info";
};
export type QueuedJob_info$key = {
  readonly " $data"?: QueuedJob_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"QueuedJob_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QueuedJob_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repository",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalUrl",
      "storageKey": null
    }
  ],
  "type": "GithubWorkflowJobInfo",
  "abstractKey": null
};

(node as any).hash = "aa5328abdfa973c2313d51ba1552e323";

export default node;
